import Vue from 'vue';
import buildApiQuery from '@/lib/buildApiQuery';
import isEqual from 'lodash/isEqual';
import nonreactive from '@/lib/nonreactive';
import handleErrors from '@/lib/handleErrors';

const moduleState = {
  geojson: {
    type: 'FeatureCollection',
    features: [],
  },
  count: 0,
  currentApiQuery: {},
  stationsError: null,
};

const moduleGetters = {
  stationPointsGeojson: (state) => state.geojson,
  stationPointCount: (state) => state.count,
  getStationsError: (state) => state.stationsError,
};

const mutations = {
  saveStationPointsCurrentApiQuery(state, apiQuery) {
    state.currentApiQuery = apiQuery;
  },

  saveStationPoints(state, payload) {
    const geojson = {
      type: 'FeatureCollection',
      features: [],
    };

    if (payload && payload.data && payload.data.fuel_stations) {
      state.count = payload.data.total_results;

      for (let i = 0, len = payload.data.fuel_stations.length; i < len; i += 1) {
        const station = payload.data.fuel_stations[i];
        geojson.features.push({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [station.longitude, station.latitude],
          },
          properties: {
            id: station.id,
            fuel: station.fuel_type_code,
          },
        });
      }
    } else {
      state.count = 0;
    }

    state.geojson = nonreactive.frozen(geojson);

    if (payload) {
      state.currentApiQuery = payload.apiQuery;
    }
  },

  setStationsError(state, status) {
    state.stationsError = status;
  },
};

const actions = {
  async fetchStationPoints({ commit, state, getters }, query) {
    try {
      const apiQuery = {
        ...buildApiQuery(getters, query),
        response_format: 'compact',
      };
      if (isEqual(apiQuery, state.currentApiQuery)) {
        return;
      }

      commit('setLoadingStationPoints', true);
      commit('saveStationPointsCurrentApiQuery', apiQuery);
      const response = await Vue.axios.get(`${process.env.VUE_APP_API_URL_ROOT}/v1.json`, {
        params: apiQuery,
      });
      commit('saveStationPoints', {
        apiQuery,
        data: response.data,
      });
      commit('setStationsError', null);
    } catch (e) {
      commit('saveStationPoints');
      commit('setStationsError', handleErrors(e));
    } finally {
      commit('setLoadingStationPoints', false);
    }
  },
};

export default {
  state: moduleState,
  getters: moduleGetters,
  mutations,
  actions,
};
